import { Grid, TextField } from "@mui/material";
import React, { ChangeEvent } from "react";
import { useIntl } from "react-intl";

interface TitleDescriptionProps {
  title: string;
  description: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  fieldName: "title" | "role";
}

const TitleDescription: React.FC<TitleDescriptionProps> = ({
  title,
  description,
  handleChange,
  fieldName
}) => {
  const intl = useIntl();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          name={fieldName}
          type="text"
          value={title}
          onChange={handleChange}
          label={
            intl.formatMessage({
              id: fieldName === "title" ? "apartment-title" : "job-role", // Adjust label based on fieldName
              defaultMessage:
                fieldName === "title"
                  ? "Give your listing a catchy title!"
                  : "Enter the job role!",
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="description"
          value={description}
          onChange={handleChange}
          label={intl.formatMessage({
            id: "description",
            defaultMessage: "Description",
          })}
          multiline
          rows={4}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default TitleDescription;
